import UIConstants from '../../constants/UIConstants';

const addDefaultLayoutToSection = (section) => {
    if (!section || !!section.layout) {
        return section;
    }
    return { ...section, layout: UIConstants.SECTION_LAYOUT.BASIC_LEFT };
};

export default addDefaultLayoutToSection;
